import { Button } from '@/components/ui/button';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useParallaxRef } from '@/utils/parallax';

export default function SupportTab() {
  const subtitleRef = useParallaxRef({ speed: -0.10, axis: 'y', maxTranslate: 32 });

  return (
    <>
      <CardHeader className="text-center pb-12">
        <CardTitle className="text-4xl md:text-5xl font-bold mb-6">Support</CardTitle>
        <CardDescription ref={subtitleRef as any} className="text-xl md:text-2xl text-foreground/70 mb-20">
          Need help with your domain or billing?
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 pt-4">
        <p className="text-muted-foreground">
          Our support team is here to help you with any questions or issues you may have.
        </p>

        <div className="flex flex-wrap gap-3">
          <Button asChild>
            <a href="/contact">Contact Support</a>
          </Button>
          <Button variant="outline" asChild>
            <a href="/support">View FAQs</a>
          </Button>
        </div>

        <div className="border-t pt-6">
          <h3 className="text-sm font-medium mb-3">My Requests</h3>
          <div className="border rounded-lg p-4">
            <p className="text-sm text-muted-foreground">Coming soon</p>
          </div>
        </div>
      </CardContent>
    </>
  );
}

